import { memo } from "react";
import { Autocomplete } from "./autocomplete";
import { Flex } from "./flex";
import { LabeledInput } from "./labeled-input";

export interface ProductVariantInfo {
  variantId: string;
  name: string;
  imageSrc: string;
}

export interface ProductState {
  loading: boolean;
  options: ProductVariantInfo[];
  onProductsInputChange: (event: any, value: string) => void;
}

export const ProductAutocomplete = memo(function ProductAutocomplete({
  label,
  value,
  setValue,
  productsState,
}: {
  label: string;
  value: ProductVariantInfo | null | undefined;
  setValue: (value: ProductVariantInfo | null | undefined) => void;
  productsState: ProductState;
}) {
  return (
    <LabeledInput label={label}>
      <Autocomplete
        blurOnSelect
        filterOptions={(x) => x}
        getLabel={(product) => product?.name}
        keyFn={(product) => product?.variantId}
        multiple={false}
        noOptionsText={productsState.loading ? "Loading..." : "No options"}
        onInputChange={productsState.onProductsInputChange}
        options={productsState.options || []}
        value={value}
        valueChange={(value) => setValue(value)}
      >
        {(product) => (
          <Flex align="center">
            <img
              src={product?.imageSrc}
              style={{ height: "40px", borderRadius: "4px" }}
            />{" "}
            {product?.name}
          </Flex>
        )}
      </Autocomplete>
    </LabeledInput>
  );
});
